// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__tPJ1J","upload":"Small_upload__1NvdZ","imageWrap":"Small_imageWrap__2Adfo","removeBtn":"Small_removeBtn__2pwlA"};